export default class HeightEquipment {
  name?: string;

  constructor(name: string) {
    this.name = name;
  }
}
